import BaseResource from './index'

export default class UnionLocalResource extends BaseResource {
    static endpoint = '/oasis/restv3/unionLocals'
    static cacheMaxAge = 60
}
